<template>
  <div class="a-accordion">
    <div class="a-accordion__btn-tab">
      <div class="a-accordion__label a-accordion__label--open">
        <img src="@/assets/img/static/arrow-vector.png" alt="">
        {{$t('labels.catalog-upper-level')}}
      </div>

      <button class="a-accordion__add-btn-label" type="button" @click="createNewItem">
        <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
        {{$t('form.catalogs.catalog-type.price-criteria.add-criterion')}}
      </button>
    </div>

    <price-criteria-catalog-list
      v-if="documents"
      :documents="documents"
      @addItem="createNewItem($event)"
      @editItem="editItem($event)"
      @deleteItem="deleteItem($event)"
      @confirmEditable="confirmEditable($event)"
      @cancelEditable="cancelEditable($event)"
    >
    </price-criteria-catalog-list>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import PriceCriteriaCatalogList from './PriceCriteriaCatalogList';
  import Loading from '@/components/Loading'
  import _ from 'lodash'

  let uniqueId = Date.now();

  export default {
    components: {
      PriceCriteriaCatalogList,
      Loading
    },

    computed: {
      documents() {
        return this.$store.getters.priceCriteria.items;
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchPriceCriteriaFromCatalog');
        }
        catch(e) {
          console.error('unable to fetch list of price criteria from catalog', e);
          this.globalErrorHandler(e);
        }
      });
    },

    methods: {
      createNewItem(data) {
        this.documents.unshift({
          name: undefined,
          isText: false,
          isFile: false,

          editable: true,
          isNew: true,

          localId: ++uniqueId
        })
      },

      deleteItem(data) {
        const idx = _.findIndex(this.documents, { id: data.id });
        if (idx === -1) return;

        this.runAction(async() => {
          try {
            await this.$store.dispatch('deleteCriteriaFromCatalog', { ...data });
          }
          catch(e) {
            console.error('unable to delete criterion from catalog', e);
            this.globalErrorHandler(e);
          }
        });
      },

      editItem(data) {
        const idx = _.findIndex(this.documents, { id: data.id });
        if (idx === -1) return;

        const item = this.documents[idx];
        item.editable = true;
        item.backup = {
          name: item.name,
          isText: item.isText,
          isFile: item.isFile
        };

        this.$set(this.documents, idx, item);
      },

      findElement(data) {
        let fieldId = 'id';

        if (data[fieldId] === undefined) {
          fieldId = 'localId';
        }

        const filter = {};
        filter[fieldId] = data[fieldId];

        const idx = _.findIndex(this.documents, filter);
        return idx;
      },

      async confirmEditable(data) {
        const idx = this.findElement(data);
        if (idx === -1) return;

        const item = this.documents[idx];

        if (item.isNew) {
          item.id = Date.now();
        }

        this.runAction(async () => {
          try {
            if (item.isNew) {
              await this.$store.dispatch('addCriteriaToCatalog', { ...data, type: 'price' });
            }
            else {
              await this.$store.dispatch('modifyCriteriaInCatalog', { ...data, type: 'price' });
            }
            item.editable = false;
          }
          catch(e) {
            console.error('unable to add/modify criterion to/in catalog', e);
            this.globalErrorHandler(e);
          }
        });
      },

      cancelEditable(data) {
        const idx = this.findElement(data);
        if (idx === -1) return;

        const item = this.documents[idx];

        if (item.isNew) {
          this.documents.splice(idx, 1);
        }
        else {
          item.name = item.backup.name;
          item.isFile = item.backup.isFile;
          item.isText = item.backup.isText;
          item.editable = false;
          this.$set(this.documents, idx, item);
        }
      }
    }
  }
</script>

<style scoped>

</style>
